import { IStore } from "../store";

export const canViewByRoleCodes = (store: IStore, roleCodes: string[], action: "ALLOW" | "DENY") => {
  if (!store.global.role?.code) {
    return false;
  }

  if (roleCodes.includes(store.global.role.code)) {
    if (action === "ALLOW") {
      return true;
    }

    return false;
  } else {
    if (action === "ALLOW") {
      return false;
    }

    return true;
  }
};
